import config from './config'

export const FeatureFlagAPI = {
    getFeatureFlags: () => {
        return config.get('/api/organization/features/')
    },
    getClerkStatus: () => {
        return config.get('/clerk-status/')
    },
}
